var render = function render(){var _vm=this,_c=_vm._self._c;return _c('clickable-icon',{staticClass:"sidebar-action-btn",attrs:{"bg_color":"gray-200","rounded":false},on:{"clicked":function($event){return _vm.$emit('clicked')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }